export default __webpack_public_path__ + "static/media/Icon_File_01.ea8a9fdd.svg";